import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/molecules/fnpChatLoader/index.jsx");
import(/* webpackMode: "eager" */ "/usr/src/app/src/globals.css");
import(/* webpackMode: "eager" */ "/usr/src/app/src/store/reduxProvider.js")